var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"wrap",staticClass:"wrap"},[_c('transition',{attrs:{"name":"router-animation"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }